import { ERROR } from '../constants/MessageType';
let incrementingId = 0;
export const createTimeoutMessage = threadId => ({
  actions: [],
  displayType: 'TIMEOUT_MESSAGE',
  id: incrementingId++,
  query: {
    intent: 'unknown'
  },
  source: 'CHAT',
  status: 'timeout',
  response: '',
  value: '',
  time: Date.now(),
  thread_id: threadId,
  type: ERROR
});